import { Collapse, Empty, Space } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";

import { EditableSpecAccess } from "../EditableSpecAccess";
import { SingleSpecAccessEditor } from "../SingleSpecAccessEditor";
import { SpecificationsAccessStore } from "../SpecificationsAccessStore";

type PropsSpecsListAccessEditor = {
  specList: EditableSpecAccess[];
  store: SpecificationsAccessStore;
};

export const SpecsListAccessEditor: React.FC<PropsSpecsListAccessEditor> =
  observer((props) => {
    const { specList, store } = props;
    if (specList.length === 0) {
      return (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description="Нет спецификаций"
        />
      );
    }
    const first = specList[0];
    return (
      <Collapse
        items={specList.map((spec) => {
          const details = spec.displayName || spec.description;
          return {
            key: spec.id,
            label: (
              <Space>
                <span>{spec.name}</span>
                {details && <span style={{ color: "gray" }}>({details})</span>}
              </Space>
            ),
            children: (
              <SingleSpecAccessEditor
                attributes={spec.attributes}
                store={store}
              />
            ),
          };
        })}
        defaultActiveKey={first ? [first.id] : undefined}
      />
    );
  });
